/**
 * Regex patterns
 * -
 * Please keep in alphabetical order
 * and add a comment for each regex explaining its purpose and example
 * along with where it is being used
 * use AI if needed
 */

export const ALPHANUMERIC_REGEX = /^[A-Za-z0-9]+(\s[A-Za-z0-9]+)*$/;
// Starts with at least one letter or digit: [A-Za-z0-9]+
// Then may have zero or more groups of (space + one or more letters/digits): (\s[A-Za-z0-9]+)*
// Used in OLA fields like ID, Loan Purpose, VIN, etc

export const ALPHANUMERIC_APOSTRPHE_HYPHEN_PERIOD_SLASH_SPACE_REGEX = /^[A-Za-z0-9\s-./"'"]*$/;
// Uppercase/lowercase letters (a-zA-Z)
// Digits (0-9)
// Spaces, hyphens (-), periods (.), slashes (/), apostrophes ('), and double quotes (")
// Used in OAO Previous city

export const ALPHANUMERIC_COMMA_SPACE_REGEX = /^[a-zA-Z0-9 ,]*$/;
// Uppercase/lowercase letters (a-zA-Z)
// Digits (0-9)
// Spaces and commas ( ,)
// DEPRECATED, need to remoce alphaNumericOnly from field validation

export const ALPHANUMERIC_HYPHEN_SPACE_REGEX = /^[A-Za-z0-9\s-]*$/;
// Uppercase/lowercase letters (a-zA-Z)
// Digits (0-9)
// Spaces and hyphens ( -)
// Used in OLA ID fields

export const DATE_REGEX =
  // eslint-disable-next-line max-len
  /^((0[13578]|1[02])[\/.](29|30|31)[\/.](19|20)[0-9]{2})|((01|0[3-9]|1[1-2])[\/.](29|30)[\/.](19|20)[0-9]{2})|((0[1-9]|1[0-2])[\/.](0[1-9]|1[0-9]|2[0-8])[\/.](19|20)[0-9]{2})|((02)[\/.]29[\/.](((19|20)(04|08|[2468][048]|[13579][26]))|2000))$/;
// Covers the usual scenario (no special edge cases)
// Ensures you can only have 02/29 on correct leap years
// Examples: 02/29/2000 or 02.29.2020
// What It Allows:
// Valid month/day combos in the range 01/01/1900 … 12/31/2099
// Both slash (/) and dot (.) separators
// 02/29 only if it’s a valid leap year
// Correct days for each month (e.g., 31st not allowed in April, 30th not allowed in February, etc.)
// Used in OAO and OLA date fields

export const DECIMAL_REGEX = /^[^.]*./;
// TODO: evaluate this regex and usage - why are we allowing alphanumeric for decimal.
// added here because it was used for allowedDecimals in validiation service.

export const EIN_REGEX = /^[0-9]{2}([ -]?)[0-9]{7}$/;
// Validates US Employer Identification Numbers (EINs).
// Two digits at the start: [0-9]{2}
// An optional space or dash: ([ -]?)
// Seven digits at the end: [0-9]{7}
// The entire string must match from start (^) to finish ($)
// Examples: "12-3456789", "12 3456789", "123456789"
// Used in OAO business fields

export const EMAIL_REGEX =
  // eslint-disable-next-line max-len
  /^(?!.*\.\.)(?!\.)(?!.*\.$)(?!.*\.-)(?!.*-\.)[a-zA-Z0-9_%+-](?:[a-zA-Z0-9._%+-]{1,60}[a-zA-Z0-9_%+-])?@[a-zA-Z0-9](?:[a-zA-Z0-9-]{1,60}[a-zA-Z0-9])?(?:\.[a-zA-Z]{2,15})+$/;
// Note: Make sure we have this regex in sync with login/registration
// (?!.*\.\.) negative lookahead to prevent consecutive dots
// limit local character count {1,60}, domain {1,60}, TLD {2,15} to resolve ReDoS vulnerability

export const NAME_REGEX = /^[a-zA-Z]+([ '-][a-zA-Z]+)*$/;
// Starts with one or more letters
// Then zero or more groups of (space/apostrophe/hyphen + one or more letters)
// No leading or trailing spaces, apostrophes, or hyphens
// No double spaces or double hyphens/apostrophes
// Examples: "John", "Mary-Jane", "O'Neill", "Anna Maria"

export const NO_SPACES_REGEX = /^[\S]*$/;

export const NUMERIC_REGEX = /^[0-9]*$/;
// Matches an entire string of zero or more digits.
// Accepts an empty string or “1234.”
// Must not contain any non-digit characters.

export const PHONE_REGEX = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/;
// * Optional Country Code (1\s?)?
// The digit “1” followed by an optional space.
// Example: "1 (123) 456-7890"
// * Area Code ((\([0-9]{3}\))|[0-9]{3})
// Either three digits enclosed in parentheses (e.g. "(123)")
// Or just three digits (e.g. "123")
// * Optional Separator [\s\-]?
// A space or a dash, or nothing at all
// * Next 3 Digits [0-9]{3}
// The middle part of the phone number
// * Optional Separator [\s\-]?
// A space or a dash, or nothing
// * Last 4 Digits [0-9]{4}
// Final portion of the phone number
// Examples: "5555555555", "555-555-5555", "(555) 555 5555", "1 (555) 555-5555", "1 555-555-5555"

export const POBOX_REGEX = /\b(?:p[\W_]*o[\W_]*box|post[\W_]*office[\W_]*box|p[\W_]*o[\W_]*b)\d*\b/i;
// \b: Word boundary to ensure it matches whole words.
// (?:...): Non-capturing group for alternatives.
// [\W_]*: Matches any number of non-word characters or underscores (e.g., spaces, dashes, dots).
// \d*: Matches any number of digits (e.g., box numbers).
// /i: Case-insensitive flag.
// Matches: PO Box 123, P.O. Box 456, Post Office Box 789, P O Box 1011, P_O_Box_1213,
// P-O-B 1415, p.o.box, p o b, post_office_box, P.O.B123, p-o box, p_o box

export const REMOVE_NON_NUMERIC_REGEX = /[^0-9]/g;
// matches zero or more non-digit characters (including an empty string)
// Matches each individual non-digit character, globally (all occurrences).
// Example: "abc123" → matches "a", "b", "c" (each separately).
// Used for replacing or removing all non-digit characters one by one.

export const SSN_REGEX = /^(?!000)\d{3}[-\s]?\d{2}[-\s]?\d{4}$/;
// Validates US Social Security Numbers (SSNs).
// Ensures the first three digits are not "000": (?!000)\d{3}
// Allows optional separators (space or dash) between digit groups: [-\s]?
// Matches the full SSN format from start (^) to finish ($)
// Valid Examples: "123-45-6789", "123 45 6789", "123456789", "123-00-6789", "123 00 6789", "123006789", "123-45-0000", "123450000", "123 45 0000"
// Invalid Examples: "000-12-3456", "000 12 3456", "000123456", "000-00-0000", "000000000", "000 00 0000"
// Used in OAO and OLA personal information fields

export const ZIPCODE_REGEX = /^[0-9]{5}$/;
// Common US 5-digit ZIP code format.
// Numbers only
